<template>
  <div class="photoinfobtn shadow mdl show-popup-right mr-1">
    <button @mouseenter="getInfo(photo, '', $event)" type="button" class="btn btn-info-popup info-popup-hover shadow-sm rounded">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
    </button>
    <div class="photoinfo p-0">
      <div class="border p-2 border shadow rounded">
      <table class="table table-hover p-2">
        <tr>
          <td><strong>Foto Id:</strong></td>
          <td>{{photo.runid}}
            <button v-if="isConstruction !== false" class="btn btn-light float-right" @click="setPhotoIdInDescription(photo.runid , textId)">
              Foto-ID hinzufügen
            </button>
          </td>
        </tr>
        <tr>
          <td><strong>Datum:</strong></td>
          <td>{{photo.photodate | date}} {{ photo.photodate.substr(11,5) }}Uhr</td>
        </tr>
        <tr>
          <td> <strong>Dateiname:</strong> </td>
          <td>  {{photo.origname | LiveSubStr('15')}}</td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td><strong>Ersteller:</strong></td>
          <td> {{ creator }} ({{ photo.pduserid }})</td>
        </tr>
        <tr>
          <td><strong>Plan:</strong></td>
          <td> {{ planname }}</td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td><strong>Schlagworte:</strong></td>
          <td>
            <span class="p-1 badge font12 border" v-for="tag in  photo.params" >  {{tag.name}}  </span>
          </td>
        </tr>
        <tr class="sep">
          <td colspan="2"></td>
        </tr>
        <tr>
          <td colspan="2"><strong>Fotobeschreibung</strong>
            <p>{{photo.description}}</p>
          </td>
        </tr>
        <tr v-if="isConstruction">
          <td colspan="2">
            <button v-if="textId" class="pt-1 pb-1 pr-2 pl-2 rounded btn-primary font13 text-white" @click="setTextInDescription(photo.description , textId)">
              Text übertragen
            </button>
            <button v-else class="pt-1 pb-1 pr-2 pl-2 rounded btn-secondary font13 text-white" disabled>
              Text übertragen
            </button>
          </td>
        </tr>
      </table>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios'
import {mapState} from 'vuex'
import {formatDate} from '../../../common'
export default {
  props: ['photo','isConstruction'],
  filters: {
    LiveSubStr: function(string, len) {
      if(string.length <= len) {
        return string
      }
      return string.substring(0,len) + '...';
    },
    date: (val) => formatDate(val)
  },
  data () {
    return {
      getMemosUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photo/' + this.photo.id + '/getmemos',
      memos: '',
      planname: '',
      creator: '',
      tags: []
    }
  },
  computed: {
    ...mapState({
      projectUsers: state => state.appSettings.projectUsers,
      textId: state => state.constructionDiary.activeTextareaId,
      report: state => state.constructionDiary.reportDetailsCopy
    }),
  },
  methods: {
    setTextInDescription(text, value){
       this.report.groups.forEach(item =>  {
         if (item.crgroupid === value.crgroupid){
              item.groupvalues.forEach(group => {
                if (group.crgroupfieldvalueid === value.crgroupfieldvalueid){
                    group.crgroupfieldvalue = group.crgroupfieldvalue ?  `${group.crgroupfieldvalue}\n${text}` : text
                }
              });
          }
       });
    },

    setPhotoIdInDescription(text, value){
      this.report.groups.forEach(item =>  {
        if (item.crgroupid === value.crgroupid){
          item.groupvalues.forEach(group => {
            if (group.crgroupfieldvalueid === value.crgroupfieldvalueid){
              group.crgroupfieldvalue = `${group.crgroupfieldvalue}\n#${text}`
            }
          });
        }
      });
    },



    async getDetails (photo) {
      let _this = this
      let id = photo.pdphotoid
      let pduserid = photo.pduserid
      this.creators = _this.projectUsers

      // let url = process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photo/' + id + '/getdetails'
      let params = {
        "methodName": "getPlansOfPhoto",
        "parameters": [id],
        "serviceName": "ProjectdocuService"
      }
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getPlansOfPhoto&token=` + localStorage.sessiontoken, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
        .then(response => {
          if (response.status === 200) {
            let planname = ''
            if(response.data.plans.length >= 1) {
              response.data.plans.forEach(function(value, i) {
                if(i > 0) {
                  planname = planname + ', '
                }
                planname = value.description ? value.description : value.origname
              })
              this.planname = planname
            } else {
              this.planname = 'Kein Plan'
            }
            _this.creator = 'unbekannt';
            this.creators.forEach(function(value, idx) {
              if(pduserid === value.pduserid) {
                _this.creator = value.firstname + ' ' + value.lastname
              }
            })
            this.creator = _this.creator
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    async getTags () {
      axios.get(this.getTagsUrl, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status === 200) {

          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    getInfo (id, pduserid , event) {
      this.getDetails(id, pduserid)
      if(event.screenX <= 400) {
        $('.photoinfobtn').addClass('show_infobox_right')
      } else {
        $('.photoinfobtn').removeClass('show_infobox_right')
      }

      if((event.y + 300) >= $('body').outerHeight()) {
        $('.photoinfobtn').addClass('show_infobox_top')
      } else {
        $('.photoinfobtn').removeClass('show_infobox_top')
      }
    },

    async getMemos () {
      axios.get(this.getMemosUrl, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string',
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status === 200) {

          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    }
  }
}


</script>
<style scoped>
/*.photoinfobtn,.photoinfo{*/
/*  z-index: 99999;*/
/*  right: 5px;*/
/*  top: 7px;*/
/*  left: -48px;*/
/*  border: 0;*/
/*}*/
.photoinfobtn,.photoinfo{
  z-index: 999;
}
.show_infobox_right .photoinfo {
  right: auto !important;
  left: 5px !important;
}
.modal-images-popup .show-popup-right .photoinfo {
  right: auto !important;
  left: 5px !important;
}
.photoinfobtn button.btn{
  z-index: 99;
  position: relative;
  padding-inline: 6px;
  padding-block: 4px;
  background-color: rgba(239, 239, 239, 0.8);
  margin: 0;
  line-height: 1;
  color: #464343;
  float: left;
  border-radius: 0;
  font-size: 18px;
  top: 3px;
}
.photoinfobtn button.btn:hover{
  background-color: rgba(211, 211, 211, 0.8);
}
.photoinfobtn button.btn-info-popup{
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.photoinfobtn button.btn-edit-photo{
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
</style>





// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/PhotoInfoPopup.vue